import classNames from 'classnames';
import { ComponentProps } from 'react';

type StatsOwnProps = {
  label: string,
  current: number,
  total: number,
  notFilledApplications?: number,
  className?: string,
};
type StatsProps = StatsOwnProps & Omit<ComponentProps<'div'>, keyof StatsOwnProps>;

const Stats = ({ label, current, total, notFilledApplications, className = '', ...rest }: StatsProps) => (
  <div className={classNames('text-secondary-transparent-48 flex text-caption-xl justify-center border rounded-md border-secondary-transparent-5 bg-secondary-transparent-5 h-5', className)} {...rest}>
      <span className={classNames(
        'flex justify-center items-center',
        'border-r border-secondary-transparent-5',
        'w-full'
      )}
      >
      {current}/{total}
      </span>
      <span className={classNames(
        'w-7 flex justify-center items-center',
      )}
      >
        {notFilledApplications}
      </span>
  </div>
);

export default Stats;
